const TestimonialsSection = () => {
  const testimonials = [
    {
      icon: 'ri-car-line',
      industry: '自動車部品メーカー',
      location: '岡山市',
      rating: 5,
      title: '試作開発に欠かせないパートナー',
      content: '新製品の試作で特殊なネジが必要になり困っていましたが、1本から対応していただけて本当に助かりました。0.01mm単位の精度で、図面通りの製品を短納期で納品していただけます。岡山市内で信頼できる加工業者を探していた私たちにとって、最高のパートナーです。',
    },
    {
      icon: 'ri-plane-line',
      industry: '航空機器メーカー',
      location: '岡山市',
      rating: 5,
      title: 'チタン加工の技術力に感動',
      content: 'チタン製の特注ネジ加工を依頼しましたが、その技術力の高さに驚きました。難削材の加工経験が豊富で、他社では断られた案件も快く引き受けていただけました。創業50年の実績と職人の技術力は本物です。',
    },
    {
      icon: 'ri-hospital-line',
      industry: '医療機器メーカー',
      location: '岡山市',
      rating: 5,
      title: '小ロット対応が嬉しい',
      content: '医療機器の試作で少量の特注ネジが必要でしたが、1本から対応していただけるのは本当にありがたいです。品質も申し分なく、納期も守っていただけるので安心して依頼できます。岡山市でこのような技術を持つ町工場があることを誇りに思います。',
    },
    {
      icon: 'ri-cpu-line',
      industry: '精密機器メーカー',
      location: '岡山市',
      rating: 5,
      title: '規格品では対応できない課題を解決',
      content: '既存の規格品では対応できず困っていた特殊形状のネジを製作していただきました。図面を見せただけで、すぐに対応方法を提案していただき、その技術力と経験に感銘を受けました。岡山市の製造業を支える素晴らしい企業です。',
    },
  ];

  return (
    <section className="py-16 sm:py-20 lg:py-28 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 sm:mb-12 lg:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-navy mb-4 sm:mb-6">
            お客様の声
          </h2>
          <p className="text-base sm:text-lg text-gray-600 max-w-3xl mx-auto">
            岡山市を中心に、多くの企業様にご利用いただいています
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 sm:gap-8 lg:gap-10">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-6 sm:p-8 shadow-md hover:shadow-xl transition-all duration-300 flex flex-col"
            >
              <div className="flex items-center mb-3 sm:mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-500 text-lg sm:text-xl"></i>
                ))}
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-navy mb-3 sm:mb-4">
                {testimonial.title}
              </h3>
              <p className="text-sm sm:text-base text-gray-600 leading-relaxed mb-6 sm:mb-8 flex-grow">
                {testimonial.content}
              </p>
              <div className="flex items-center">
                <div className="w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center bg-navy rounded-full flex-shrink-0">
                  <i className={`${testimonial.icon} text-2xl sm:text-3xl text-white`}></i>
                </div>
                <div className="ml-4">
                  <p className="text-sm sm:text-base font-bold text-navy">
                    {testimonial.industry} 設計担当者様
                  </p>
                  <p className="text-xs sm:text-sm text-gray-500">{testimonial.location}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;